import React from 'react';

interface DrgRow {
  arithmeticMeanLOS?: number;
}

/**
 * Length of Stay display with 2 decimal places
 */
export const LosTemplate: React.FC<{ los: number | null | undefined }> = ({ los }) => {
  const value = los ?? 0;
  return <span>{value.toFixed(2)}</span>;
};

// Template function for grid column
export const losTemplate = (props: DrgRow) => <LosTemplate los={props.arithmeticMeanLOS} />;

export default LosTemplate;
